// extracted by mini-css-extract-plugin
module.exports = {"container":"TalisParticipationManual_container__24dZb"};